<h1>ファイルダウンロード</h1>
<mat-card appearance="outlined" class="cur-card">
  <mat-card-header>
    <mat-card-title>検索条件</mat-card-title>
    <mat-icon>search</mat-icon>
  </mat-card-header>
  <mat-card-content>

    <form [formGroup]="searchConditionForm" >
      <app-file-download-condition (onClickSearchEvent)="getFileList()" (onClickClearEvent)="onClickClear()">
      </app-file-download-condition>
    </form>
  </mat-card-content>
</mat-card>

<div *ngIf="searched">
  <app-file-download-result [responseList]=responseList (rowClickEvent)="fileDownload($event)">
  </app-file-download-result>
</div>
